import CryptoJS from "crypto-js";
import { globalConstants } from "../constants";
import {
  getItemFromStorage,
  removeItemFromStorage,
  clearStorage,
} from "./storage";

//Encrypt object for secret key
export const encryptObject = (object) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(object),
    process.env.REACT_APP_CRYPTO_JS_KEY
  ).toString();
};

//Decrypt object for secret key
export const decryptObject = (encryptedString) => {
  try {
    if (encryptedString !== globalConstants.EMPTY_STRING) {
      const bytes = CryptoJS.AES.decrypt(
        encryptedString,
        process.env.REACT_APP_CRYPTO_JS_KEY
      );
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } else {
      return {};
    }
  } catch (e) {
    removeItemFromStorage(process.env.REACT_APP_PAYLOAD);
    clearStorage();
    window.location.reload();
  }
};

//Decrypt Payload
export const getDecryptPayload = () => {
  const encryptedPayload =
    getItemFromStorage(process.env.REACT_APP_PAYLOAD) || globalConstants.EMPTY_STRING;
  return decryptObject(encryptedPayload);
};

//Decrypt Payload
export const getDecryptUserData = () => {
  const encryptedPayload =
    getItemFromStorage("encryptedData") || globalConstants.EMPTY_STRING;
  return decryptObject(encryptedPayload);
};

//Get token for decrypt payload
export const getToken = () => {
  return getDecryptPayload();
};

export const getUserData = () => {
  return getDecryptUserData();
};
